import React, { useEffect, useState } from "react";
import {
  Container,
  Columns,
  HeaderContainer,
  LogoutButton,
  SelectContainer,
  TwoColumnGrid,
} from "../app.style";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { MagazineSelect } from "../components/form.style";
import ArticleForm from "../components/form.component";
import ArticleList from "../components/article-list.component";
import Auth from "../components/auth.component";
import { firebaseAuth, firebaseDB } from "../firebaseConfig";
import { onValue, ref } from "firebase/database";

const db = firebaseDB;

const AdminScreen = () => {
  const auth = firebaseAuth;
  const [user, setUser] = useState(null);
  const [articles, setArticles] = useState([]);
  const [magazine, setMagazine] = useState(null);
  const [editingArticle, setEditingArticle] = useState(null); // Zustand für den zu bearbeitenden Artikel
  const [newestArticleID, setNewestArticleID] = useState(0);

  useEffect(() => {
    if (magazine && articles) {
      setNewestArticleID(getNewestArticleID());
    }
  }, [magazine, articles]);

  const getNewestArticleID = () => {
    let highestID = 0;

    articles.forEach((item) => {
      const currentId = parseInt(item.id, 10);
      if (currentId > highestID) {
        highestID = currentId;
      }
    });

    return highestID + 1;
  };

  const handleMagazineChange = async (e) => {
    setMagazine(e.target.value);
    fetchArticles(e.target.value).catch((e) => console.log(e));
  };

  const handleEditingArticle = (article) => {
    setEditingArticle(article);
  };

  const fetchArticles = async (magazine) => {
    await onValue(ref(db, `articles/${magazine}`), (snapshot) => {
      const data = snapshot.val();
      setArticles(data);
    });
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
    });
    return () => unsubscribe();
  }, [auth, user]);

  return (
    <main>
      <section>
        <Container>
          {user ? (
            <>
              <Columns>
                <HeaderContainer>
                  <h2 style={{ margin: 0 }}>Willkommen, {user.displayName}!</h2>
                  <p
                    style={{
                      fontSize: "0.75rem",
                      width: "50%",
                      marginBottom: "0.5em",
                      marginTop: 0,
                    }}
                  >
                    Hier kannst du neue Artikel für den KATAPULT Verlag
                    erstellen und die alle bereits gespeicherten Artikel in der
                    Datenbank anschauen.
                  </p>
                  <LogoutButton onClick={() => signOut(auth)}>
                    Abmelden
                  </LogoutButton>
                </HeaderContainer>
                {/* Magazin-Auswahl */}
                <SelectContainer>
                  <h2 style={{ margin: 0 }}>Auswahl Magazin</h2>
                  <p
                    style={{
                      fontSize: ".75rem",
                      marginBottom: "0.5em",
                      marginTop: 0,
                    }}
                  >
                    Wähle hier zwischen den Magazinen Katapult-Magazin,
                    Katapult-Ukraine und Katapult-MV aus!
                  </p>
                  <MagazineSelect
                    id="magazine"
                    name="magazine"
                    onChange={handleMagazineChange}
                    required
                  >
                    <option>-- Magazin auswählen --</option>
                    <option value="katapult-magazin">Katapult-Magazin</option>
                    <option value="katapult-mv">Katapult-MV</option>
                    <option value="katapult-ukraine">Katapult-Ukraine</option>
                  </MagazineSelect>
                </SelectContainer>
              </Columns>
              <TwoColumnGrid>
                <ArticleForm
                  magazine={magazine}
                  editingArticle={editingArticle}
                  setEditingArticle={setEditingArticle}
                  newestArticleID={newestArticleID}
                />
                <ArticleList
                  articles={articles}
                  onEditArticle={handleEditingArticle}
                />
              </TwoColumnGrid>
            </>
          ) : (
            <Auth />
          )}
        </Container>
      </section>
    </main>
  );
};

export default AdminScreen;
